import * as React from "react";
import FullWidthImageTextCta, {
    FullWidthImageTextCtaProps
} from "~/components/full-width-image-text-cta/full-width-image-text-cta";

export interface IFullWidthImageTextCtaViewProps {
    contextModel: FullWidthImageTextCtaProps;
}

class FullWidthImageTextCtaView extends React.PureComponent<IFullWidthImageTextCtaViewProps> {
    public render() {
        return <FullWidthImageTextCta {...this.props.contextModel} />;
    }
}

export default FullWidthImageTextCtaView;
